import { Injectable } from '@angular/core';
import { ESigningOrderType } from 'core/dto';
import { subjectFromObs } from 'core/rx-js';
import { distinctUntilChanged, map, Subject } from 'rxjs';
import { IActivity } from '../../../dto-map/i-activity';
import { SignProcessWizardService } from '../../../sign-process-wizard.service';
import { SelectActivitiesStepService } from '../../2-select-activities-step/select-activities-step.service';

@Injectable()
export class ActorCardCollectionService {
  readonly #destroy = new Subject<void>()
  readonly activitiesSubject = this._selectSignersStepService.activitiesSubject;
  readonly hideGroupSubject = subjectFromObs({
    initialValue: false,
    observable: this._signProcessWizardService.processSubject.pipe(
      map(process => process.signingOrderType === ESigningOrderType.paralel),
      distinctUntilChanged()
    ),
    until: this.#destroy
  })

  readonly activitiesGroupedObs = this.activitiesSubject
    .pipe(
      map((activities) => {
        const activitiesGrouped = activities.reduce<{ [orderIndex: number]: IActivity[] }>((activitiesGrouped, activity) => {

          if (!activitiesGrouped[activity.orderIndex]) {
            activitiesGrouped[activity.orderIndex] = []
          }
          activitiesGrouped[activity.orderIndex].push(activity);

          return activitiesGrouped;
        },
          {}
        )

        return Object.entries(activitiesGrouped)
          .map(([key, value]) => [key, value] as const)
          .sort(([first], [second]) => Number(first) - Number(second));
      })
    )

  constructor(
    private readonly _selectSignersStepService: SelectActivitiesStepService,
    private readonly _signProcessWizardService: SignProcessWizardService
  ) { }




  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
